import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa5, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AddStaffModal from "./AddEventType";
import {
  getAllArea,
  getAllEvents,
  getAllStaff,
} from "../../CrudOperations/GetOperation";
import AddEventType from "./AddEventType";
import { DeleteEventType_FromDatabase } from "../../CrudOperations/DeleteOperation";

const ManageEventType = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Staff, setStaff] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEventList, setFilteredEventList] = useState([]);
  const [EventList, setEventList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentStaffId, setCurrentStaffId] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [edit, setEdit] = useState("");

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await getAllEvents();
      console.log(response);

      if (response?.data.length > 0) {
        setEventList(response.data);
        setFilteredEventList(response.data);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = EventList.filter((p) =>
      p.EventTypeName.toLowerCase().includes(query)
    );
    setFilteredEventList(filteredList);
  };

  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (Staff) {
      const response = await AddStaff({ Staff });
      if (response.data.message === "Staff saved successfully!") {
        const newStaff = { Staff, id: response.data.data.id };
        setEventList([...EventList, newStaff]);
        setFilteredEventList([...filteredEventList, newStaff]);
        setStaff("");
        toast.success("Staff added successfully!");
      } else {
        toast.error("Failed to add Staff. Please try again.");
      }
    } else {
      toast.error("Please enter a valid Staff.");
    }
  };

  const handleDeleteStaff = async (id) => {
    const DeleteResponse = await DeleteEventType_FromDatabase(id);
    console.log(DeleteResponse);

    if (DeleteResponse.ServerMessage === "EventType deleted successfully.") {
      const response = await getAllEvents();
      console.log(response);

      if (response?.data.length > 0) {
        setEventList(response.data);
        setFilteredEventList(response.data);
      }
    }
  };

  // handleUpdateStaff

  const handleUpdateStaff = async (p, Type) => {
    setEdit(p);

    setIsModalOpen(true);
  };

  const handleCheckboxChange = (id, isChecked) => {
    // Set the current Staff ID and the new status based on the checkbox state
    setCurrentStaffId(id);
    setNewStatus(isChecked ? "Available" : "Not Available");
    setIsConfirmModalOpen(true); // Open the confirmation modal
  };

  const confirmChangeStatus = async () => {
    if (currentStaffId !== null) {
      // Update status in EventList
      setEventList((prevList) =>
        prevList.map((item) =>
          item.id === currentStaffId ? { ...item, Status: newStatus } : item
        )
      );

      // Update status in filteredEventList
      setFilteredEventList((prevList) =>
        prevList.map((item) =>
          item.id === currentStaffId ? { ...item, Status: newStatus } : item
        )
      );

      try {
        const response = await UpdateStaffStatus({
          id: currentStaffId,
          Status: newStatus,
        });
        if (response.data.message === "Staff updated successfully!") {
          toast.success(`Status updated to ${newStatus} successfully!`);
        } else {
          toast.error("Error updating status.");
        }
      } catch (error) {
        toast.error("Error updating status.");
      } finally {
        setIsConfirmModalOpen(false); // Close the confirmation modal
        setCurrentStaffId(null); // Reset the ID
      }
    }
  };

  const handleAddStaffformClick = () => {
    setEdit(null); // Reset the edit state
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEdit(null); // Reset the edit state
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    const response = await getAllEvents();
    console.log(response);

    if (response?.data.length > 0) {
      setEventList(response.data);
      setFilteredEventList(response.data);
    }
    setEdit(null); // Reset the edit state
    setIsModalOpen(false); // Close the modal after adding
    toast.success("Event added or Updated successfully!");
  };

  const handleUpdate = (newStaff) => {
    console.log("Updated Staff:", newStaff);
    console.log("Editing Staff ID:", edit.id);
    console.log("Staff List:", EventList);

    setEventList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff, // Keep existing properties
              ...newStaff, // Merge properties from newStaff
            }
          : prevStaff
      )
    );

    setFilteredEventList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff,
              ...newStaff,
            }
          : prevStaff
      )
    );

    setEdit(null);
    closeModal(); // Close the modal after updating
  };

  const handleFilterChange = (e) => {
    const selectedStatus = e.target.value;

    if (!selectedStatus) {
      setFilteredEventList(EventList);
      return;
    }

    const filteredList = EventList.filter(
      (item) => item.Status === selectedStatus
    );
    setFilteredEventList(filteredList);
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Event Type
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />

        <div className="flex items-center gap-4">
          <button
            onClick={handleAddStaffformClick}
            className="bg-blue-600 text-white px-6 py-2 rounded-md flex items-center gap-2 transition-transform duration-200 hover:bg-blue-700 hover:scale-105 shadow-md shadow-blue-500 hover:shadow-lg"
          >
            <FontAwesomeIcon icon={faPlus} />
            Add Event Type
          </button>
        </div>
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {["S.No", "Event Name", "Edit"].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          {console.log(filteredEventList)}

          <tbody>
            {filteredEventList.length > 0 ? (
              filteredEventList.map((p, index) => (
                <tr
                  key={index}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                  <td className="py-3 px-4 text-center">{p.EventTypeName}</td>

                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleUpdateStaff(p, "Edit")}
                      className="text-blue-500 transition-colors duration-200 hover:text-blue-700"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>

                  {/* <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleDeleteStaff(p.EventTypeId)}
                      className="text-red-500 transition-colors duration-200 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add Staff Modal */}
      {isModalOpen && (
        <AddEventType
          closeModal={closeModal}
          onSubmit={handleSubmit}
          Staff={edit}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default ManageEventType;
